// extracted by mini-css-extract-plugin
export var header = "header-module--header--f94vf";
export var logo = "header-module--logo--pQoZW";
export var mqMinMd = "screen and (min-width: 48em)";